module.exports = __webpack_public_path__ + "img/default-profile.d4b45420.jpeg";